import policyNumberRules from "./policyNumberRules.json";

type PolicyNumberRule = {
  pattern: string;
  message?: string;
};

type PolicyNumberRules = Record<string, PolicyNumberRule>;

const rules: PolicyNumberRules = policyNumberRules as PolicyNumberRules;

const getRuleForSource = (source?: string): PolicyNumberRule => {
  if (!source) {
    return rules.default;
  }
  return rules[source] || rules.default;
};

export const validatePolicyNumberForSource = (
  policyNumber: string,
  source?: string
): { error: string; rule: PolicyNumberRule } => {
  const rule = getRuleForSource(source);
  const regex = new RegExp(rule.pattern);

  if (!policyNumber) {
    return { error: "", rule };
  }

  if (!regex.test(policyNumber)) {
    return {
      error: rule.message ?? "Please enter a valid policy number.",
      rule,
    };
  }

  return { error: "", rule };
};

